import React, { Component } from "react";
import { Icon } from 'antd';
import { tool } from "rt-sd-common";

const modifyPassword = () => {
  // tool.popUIByUcv("rtuam_UI_setting.sub_00600001-01", {}, "修改密码");
  tool.popSingleUI('/main/ModifyUserInfo',{},'修改密码')
}

export default function ModifyPassword (props) {
    return (
      <div className={props.className} onClick={modifyPassword}>
        <Icon type="setting" />
        &nbsp;&nbsp;&nbsp;
        <span>修改密码</span>
      </div>
    )
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/operation/ModifyPassword.js